export const UPDATE_URL_REWRITES = 'UPDATE_URL_REWRITES'
export const ADD_URL_REWRITE = 'ADD_URL_REWRITE'
